module.exports = __webpack_public_path__ + "img/error.0ff7814e.png";